export default async function scaffoldPublishable() {
  return {};
}
